import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight } from 'lucide-react';

interface FaqItemProps {
  question: string;
  answer: string;
}

function FaqItem({ question, answer }: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <div ref={cardRef} className="border border-white/10 rounded-lg feature-card">
      <button
        className="w-full px-6 sm:px-8 py-4 sm:py-6 text-left flex justify-between items-center text-white hover:text-[#00ffff]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-lg sm:text-xl font-semibold">{question}</span>
        <ArrowRight className={`w-5 h-5 sm:w-6 sm:h-6 transition-transform ${isOpen ? 'transform rotate-90' : ''}`} />
      </button>
      {isOpen && (
        <div className="px-6 sm:px-8 py-4 sm:py-6 border-t border-white/10">
          <p className="text-base sm:text-lg text-white/80">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default FaqItem;